import { TargetBadgeInput } from "_graphql/__generated__/globalTypes";

export const predefinedBadges: TargetBadgeInput[] = [
  {
    name: "Rookie",
    min_points: 0,
    max_points: 95,
    description:
      "The starting point for your journey. Everyone begins as a Rookie.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,
    gift_basket: [],
  },
  {
    name: "Master",
    min_points: 100,
    max_points: 195,
    description:
      "You've mastered the basics and are on your way to greater achievements.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,

    gift_basket: [],
  },
  {
    name: "Elite",
    min_points: 200,
    max_points: 295,
    description:
      "You're among the elite performers, consistently delivering results.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,

    gift_basket: [],
  },
  {
    name: "Captain",
    min_points: 300,
    max_points: 495,
    description:
      "You're leading the way and setting an example for others to follow.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,

    gift_basket: [],
  },
  {
    name: "Veteran",
    min_points: 500,
    max_points: 695,
    description:
      "Your experience and consistent high performance make you a valuable veteran.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,

    gift_basket: [],
  },
  {
    name: "Boss",
    min_points: 700,
    max_points: 795,
    description:
      "You're the boss! Top-tier performance deserves top-tier recognition.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,

    gift_basket: [],
  },
  {
    name: "Legendary",
    min_points: 800,
    max_points: 2000,
    description:
      "You've achieved legendary status with exceptional performance beyond expectations.",
    cash_equivalent: 0,
    minimum_cash_equivalent: 0,

    gift_basket: [],
  },
];
